import { Model } from '../parents/model';

export class OrderCustomerAccountModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_REFUNDED_TAXED_PRICE = 'refunded_taxed_price';

  get name() {
    return this.attributes[OrderCustomerAccountModel.ATTR_NAME];
  }

  get refundedTaxedPrice() {
    return this.attributes[OrderCustomerAccountModel.ATTR_REFUNDED_TAXED_PRICE];
  }
}
